import React from "react";
import { UX4_PRIMARY_ORANGE } from "@cart-ui/constants/Color";

const CircleTickIcon = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill={UX4_PRIMARY_ORANGE} />
        <path d="M6.5 13L10 16.5L18 8" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default CircleTickIcon;
